<template>
  <div>
    <component :is="currentLayout">
      <!-- This will dynamically switch between 'DefaultLayout' and 'SidebarLayout' -->
    </component>
  </div>
</template>

<script>
import DefaultLayout from "./layouts/DefaultLayout.vue";
import MobileLayout from "./layouts/MobileLayout.vue";

export default {
  name: "App",
  data() {
    return {
      currentLayout: DefaultLayout,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // Determine the layout based on the current route's meta field
        this.currentLayout = to.meta.layout || DefaultLayout;
      },
    },
  },
  components: {
    DefaultLayout,
    MobileLayout,
  },
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
